import { track } from '@mc/track-event'

interface TrackPurchaseNowClick {
  pageSource: string
  /** Distinguishes co-located purchase CTAs; defaults to the self-serve flow. */
  location?: string
}

interface TrackModalClick {
  pageSource: string
  action: string
}

interface TrackModalViewed {
  pageSource: string
}

export const trackPurchaseNowClick = ({
  pageSource,
  location = 'self-service-purchase',
}: TrackPurchaseNowClick) => {
  track('Enterprise Purchase Now Clicked', {
    page_source: pageSource,
    location,
  })
}

export const trackModalClick = ({ pageSource, action }: TrackModalClick) => {
  track('Modal Clicked', {
    action,
    page_source: pageSource,
    modal_type: 'self_serve_purchase_now',
    product: 'MasterClass At Work',
  })
}

export const trackModalViewed = ({ pageSource }: TrackModalViewed) => {
  track('Modal Viewed', {
    page_source: pageSource,
    modal_type: 'self_serve_purchase_now',
    product: 'MasterClass At Work',
  })
}
